import { render } from "./WeddingPhotos.vue?vue&type=template&id=402ea07f&scoped=true"
import script from "./WeddingPhotos.vue?vue&type=script&lang=js"
export * from "./WeddingPhotos.vue?vue&type=script&lang=js"

import "./WeddingPhotos.vue?vue&type=style&index=0&id=402ea07f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-402ea07f"]])

export default __exports__